<template>
    <div>
        <b-alert :show="isSuccess" variant="success">
            Thank you, your video has been added to your answer.
        </b-alert>
        <b-alert :show="hasError" variant="danger">
            {{ error }}
        </b-alert>

        <div class="form-group mb-0">
            <label>Please upload a video file</label>
            <input type="file" class="form-control" ref="picker" :disabled="isBusy" accept="video/*">
            <small class="form-text text-muted">
                <slot></slot>
            </small>

            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated"
                     role="progressbar"
                     :aria-valuenow="progress"
                     aria-valuemin="0"
                     aria-valuemax="100"
                     :style="'width: '+ progress +'%'">{{ progress != 0 ? Math.ceil(progress) + '%' : '' }}</div>
            </div>
        </div>

        <div class="form-group mb-0">
            <button type="button" class="btn btn-primary btn-sm" :disabled="isBusy" @click="handleUpload">{{ btnUploadText }}</button>
        </div>
    </div>
</template>

<script>
    import * as UpChunk from '@mux/upchunk';

    export default {
        props: {
        },

        data() {
            return {
                progress: 0,
                btnUploadText: 'Upload',
                isBusy: false,
                isSuccess: false,
                hasError: false,
                error: '',
            }
        },

        mounted() {
            this.$nextTick(function () {
                window.setInterval(() => {
                    this.heartbeat();
                }, 120000); // 2min
            })
        },

        methods: {
            // The heartbeat keeps the session alive
            heartbeat: function() {
                axios({
                    method: 'get',
                    url: '/api/heartbeat?nonce=' + Math.random()
                });
            },

            // Upload submission
            handleUpload: function() {
                // Reset everything
                this.progress = 0;
                this.isBusy = true;
                this.btnUploadText = 'Uploading...';
                this.hasError = false;
                this.isSuccess = false;
                this.error = '';

                // Pretend you have an HTML page with an input like: <input id="picker" type="file" />
                const picker = this.$refs.picker;

                axios({
                    method: 'get',
                    url: '/api/exams-mux-video/prepare-upload',
                }).then((response) => {
                    const upload = UpChunk.createUpload({
                        endpoint: response.data.url,
                        file: picker.files[0],
                        chunkSize: 5120, // Uploads the file in ~5mb chunks
                    });

                    // subscribe to events
                    upload.on('error', err => {
                        console.error('💥 🙀', err.detail);
                        this.hasError = true;
                        this.error = err.detail;
                        this.btnUploadText = 'Upload';
                        this.isBusy = false;
                        this.progress = 0;
                    });

                    upload.on('progress', progress => {
                        console.log(`So far we've uploaded ${progress.detail}% of this file.`);

                        if(progress.detail > this.progress) {
                            this.progress = progress.detail;
                        }

                        // Sometimes this is called after success
                        if(this.progress == 100) {
                            this.progress = 0;
                        }
                    });

                    upload.on('success', () => {
                        console.log("Wrap it up, we're done here. 👋");
                        this.btnUploadText = 'Upload';
                        this.isBusy = false;
                        this.hasError = false;
                        this.error = '';
                        this.isSuccess = true;
                        this.progress = 0;

                        this.$emit('video-uploaded', {
                            'id': response.data.mux_video_id,
                            'url': response.data.url
                        });
                    });
                }).catch((response) => {
                    console.log(response);
                    this.hasError = true;
                    this.error = 'An unknown error was encountered.';
                    this.btnUploadText = 'Upload';
                    this.isBusy = false;
                });
            },
        }
    }
</script>
